import { Component, OnInit } from '@angular/core';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css'],
})
export class OverviewComponent implements OnInit {
  public active = 'tests';
  @Output() emitEvaluationCode = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  sendCodeToDetail(evaluationCode: string) {
    this.emitEvaluationCode.emit(evaluationCode);
  }
}
